import { render, staticRenderFns } from "./dollar-square.vue?vue&type=template&id=43ce2a4e&"
import script from "./dollar-square.vue?vue&type=script&lang=js&"
export * from "./dollar-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ce2a4e')) {
      api.createRecord('43ce2a4e', component.options)
    } else {
      api.reload('43ce2a4e', component.options)
    }
    module.hot.accept("./dollar-square.vue?vue&type=template&id=43ce2a4e&", function () {
      api.rerender('43ce2a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/dollar-square.vue"
export default component.exports